import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Loading from './Loading';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as charts from '../../library/charts';
import * as util from '../../library/utilitys'; // optional: for number formatting

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

class DashboardPieChart extends Component {
    getTotal = (data = []) => {
        return data.reduce((sum, value) => sum + value, 0);
    };

    render() {
        const { title = 'Chart', types, chartData = {}, icon, legend = true, position = 'right', align = 'center', bg = 'primary', unit = 'คน', customText, cardWrap = true } = this.props;

        const labels = chartData.labels || [];
        const data = (chartData.datasets?.[0]?.data) || [];
        const total = this.getTotal(data);

        const chartDataset = {
            labels,
            datasets: [
                {
                    data,
                    backgroundColor: charts.getChartColors(labels.length),
                    borderWidth: 1
                }
            ]
        };

        const chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: legend,
                    position: position,
                    align: align,
                    labels: {
                        boxWidth: 12,
                        padding: 16
                    }
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const value = context.raw;
                            const label = context.label || '';
                            const percentage = ((value / total) * 100).toFixed(1);
                            return `${label}: ${util.formatNumber(value)} ${unit} (${percentage}%)`;
                        }
                    }
                },
                datalabels: {
                    display: true,
                    formatter: () => '',
                },
                centerText: {
                    display: true
                }
            },
            cutout: '65%'
        };

        const plugins = [
            {
                id: 'centerText',
                beforeDraw: (chart) => {
                    const meta = chart.getDatasetMeta(0);
                    const arc = meta?.data?.[0];
                    if (!arc) return;

                    const { ctx, chartArea } = chart;
                    ctx.save();

                    const innerRadius = arc.innerRadius;

                    const rawText = customText ?? util.formatNumber(total);
                    const textLines = Array.isArray(rawText) ? rawText : [rawText];

                    let fontSize = innerRadius / 1.8;
                    const minFontSize = 14;
                    const lineHeightRatio = 1.2;

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';

                    while (fontSize > minFontSize) {
                        ctx.font = `bold ${fontSize}px sans-serif`;

                        const maxWidth = Math.max(
                            ...textLines.map(line =>
                                ctx.measureText(String(line)).width
                            )
                        );

                        if (maxWidth < innerRadius * 1.6) break;
                        fontSize -= 1;
                    }

                    const centerX = (chartArea.left + chartArea.right) / 2;
                    const centerY = (chartArea.top + chartArea.bottom) / 2;
                    const lineHeight = fontSize * lineHeightRatio;

                    const startY =
                        centerY - ((textLines.length - 1) / 2) * lineHeight;

                    textLines.forEach((line, index) => {
                        ctx.fillText(
                            line,
                            centerX,
                            startY + index * lineHeight
                        );
                    });

                    ctx.restore();
                }
            }
        ];

        const hasData =
            Array.isArray(labels) &&
            Array.isArray(data) &&
            labels.length > 0 &&
            data.length > 0;

        const chartContent = hasData ? (
            <Doughnut
                data={chartDataset}
                options={chartOptions}
                plugins={plugins}
            />
        ) : (
            <div className="text-center py-3">ไม่พบข้อมูลปีงบประมาณดังกล่าว</div>

        );

        return (
            <React.Fragment>
                {cardWrap ? <Card className="card-border mb-0 h-100">
                    <Card.Header className={`card-header-action bg-${bg}`}>
                        <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                    </Card.Header>
                    <Card.Body className="text-center">
                        {chartContent}
                    </Card.Body>
                </Card> : chartContent}
            </React.Fragment>
        );
    }
}

export default DashboardPieChart;
